// EM is relative to nearest parent font-size and should only be used with the media query breakpoints.
const MIN_TABLET_WIDTH_EM = '36em'; // 36em = 576px
const MIN_DESKTOP_WIDTH_EM = '62em'; // 62em = 992px
const MAX_DESKTOP_WIDTH_EM = '90em'; // 90em = 1440px
// REM is relative to html font-size
export const MIN_TABLET_WIDTH_REM = '36rem';
export const MIN_DESKTOP_WIDTH_REM = '62rem';
export const MAX_DESKTOP_WIDTH_REM = '90rem';

export const mqBreakpoints = {
  tablet: `@media screen and (min-width: ${MIN_TABLET_WIDTH_EM})`,
  desktop: `@media screen and (min-width: ${MIN_DESKTOP_WIDTH_EM})`,
  maxDesktop: `@media screen and (min-width: ${MAX_DESKTOP_WIDTH_EM})`,
};
